export enum RateSource {
    SupplierHotelRate = 0,
    DidaRate = 1,
}
